import { render, staticRenderFns } from "./matterrepotree.vue?vue&type=template&id=1244da86&scoped=true&"
import script from "./matterrepotree.vue?vue&type=script&lang=js&"
export * from "./matterrepotree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244da86",
  null
  
)

export default component.exports